import { ENV } from "../Utils/constants";

export class Auth {
  baseApi = ENV.BASE_API;

  async register(data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTER}`;

      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: data.email,
          password: data.password,
        }),
      };
      const response = await fetch(url, params); // aqui mandamos la peticion al servidor
      const result = await response.json(); // aqui convertimos la respuesta en un json

      if (response.status !== 200) throw result;
      //console.log("result", result);
      return result;
    } catch (error) {
      throw error;
    }
  }
  async verify(id, accessToken, codeNumber) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.VERIFY}/${id}`;
      //console.log("codeNumber", codeNumber);
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: codeNumber,
        }),
      };
      const response = await fetch(url, params); // aqui mandamos la peticion al servidor
      const result = await response.json(); // aqui convertimos la respuesta en un json
      //console.log(response.status);
      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async login(data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.LOGIN}`;

      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: data.email,
          password: data.password,
        }),
      };
      const response = await fetch(url, params); // aqui mandamos la peticion al servidor
      const result = await response.json(); // aqui convertimos la respuesta en un json
      //console.log(response.status);
      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
  // Nueva función para reenviar el código de verificación
  async resendCode(id, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.RESEND_CODE}/${id}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  //creamos las funciones de refrescar token
  async refreshAccessToken(refreshToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REFRESH_ACCESS_TOKEN}`;

      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: refreshToken,
        }),
      };

      const response = await fetch(url, params); // aqui mandamos la peticion al servidor
      const result = await response.json(); // aqui convertimos la respuesta en un json
      if (response.status !== 200) throw result;
      // console.log(result);
      return result;
    } catch (error) {
      throw error;
    }
  }

  //guardamos en localstorage el token
  setAccessToken(token) {
    localStorage.setItem(ENV.JWT.ACCESS, token);
  }

  //obtenemos el token del localstorage
  getAccessToken() {
    return localStorage.getItem(ENV.JWT.ACCESS);
  }
  setUserId(id, code) {
    localStorage.setItem(ENV.USER.ID, id);
    localStorage.setItem(ENV.USER.CODE, code);
  }

  //obtenemos el token del localstorage
  getUserId() {
    return localStorage.getItem(ENV.USER.ID);
  }
  getUserCode() {
    return localStorage.getItem(ENV.USER.CODE);
  }
  delUserCode() {
    return localStorage.setItem(ENV.USER.CODE, "");
  }

  //hacemos lo mismo con el refresh token
  setRefreshToken(token) {
    localStorage.setItem(ENV.JWT.REFRESH, token);
  }

  getRefreshToken() {
    return localStorage.getItem(ENV.JWT.REFRESH);
  }
  //hacemos una funcion para borrar los token
  removeTokens() {
    localStorage.removeItem(ENV.JWT.ACCESS);
    localStorage.removeItem(ENV.JWT.REFRESH);
  }
}
